import { ImportCsvComponent } from '@/common/import-csv/import-csv.component';
import { NavbarModule } from '@/common/navbar/navbar.module';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'app-import-mass-rebooking',
	standalone: true,
	imports: [ImportCsvComponent, NavbarModule],
	template: `<div class="position-relative vh-100">
		<app-navbar title="Masowe płatności rozliczenia"></app-navbar>
		<app-import-csv requestUrl="/payment/mass_rebooking/" method="post"></app-import-csv>
	</div>`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImportMassRebookingComponent {}
